import { createAsyncThunk } from "@reduxjs/toolkit";
import { login } from "./authAPI";

export const loginAuth = createAsyncThunk(
    "auth/loginAuth",
    async (body, { rejectWithValue }) => {
        try{
            const response = await login(body)
            return response
        }catch(error){
            return rejectWithValue(error)
        }
    }
)